import React, {
  Fragment,
  createRef,
  RefObject,
  ChangeEvent,
} from 'react'

import { removeAllPassengersInputName } from '../../config/forms'

import getLabels from '../../utils/getLabels'

import FormShadow from '../FormShadow'
import FormCheckbox from '../FormCheckbox'

interface EditBookingFormRowHeaderPropsInterface {
  selectAllPassengersForDeletion: Function
  deselectAllPassengersForDeletion: Function

  showTravelClass: boolean
  isDeletePassengersEnabled: boolean

  allPassengerIds: string[]
}

const toggleAllRemoveOptionsRef: RefObject<HTMLInputElement> = createRef()

export default ({
  selectAllPassengersForDeletion,
  deselectAllPassengersForDeletion,
  showTravelClass,
  isDeletePassengersEnabled,
  allPassengerIds,
}: EditBookingFormRowHeaderPropsInterface) => {
  const handleRemoveChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.currentTarget.checked
      ? selectAllPassengersForDeletion(allPassengerIds)
      : deselectAllPassengersForDeletion()
  }

  return (
    <Fragment>
      {isDeletePassengersEnabled && (
        <FormCheckbox
          elementRef={toggleAllRemoveOptionsRef}
          name={removeAllPassengersInputName}
          data-element={removeAllPassengersInputName}
          handleChange={handleRemoveChange}
        />
      )}

      <span>{getLabels('id')}</span>
      <span>{getLabels('pnr')}</span>
      <span>{getLabels('first_name')}</span>
      <span>{getLabels('last_name')}</span>
      <span>{getLabels('date_of_birth')}</span>
      <span>{getLabels('gender')}</span>

      <span>{getLabels('luggage')}</span>

      {showTravelClass && (
        <span data-element="class">{getLabels('seat_class')}</span>
      )}

      <span></span>

      <FormShadow />
    </Fragment>
  )
}
